import logAmplitudeEvent from "../../../components/amplitude";

const originalDataLayerBusPush = window.dataLayerBus.push;

// Function listening for mutiny_experience_impression, application
const listenToMutinyEventInDataLayer = () => {
    window.dataLayerBus.push = function () {
        window.dataLayer?.push(...arguments);

        const latestPushedArguments = arguments[0];
        const latestPushedEvent = latestPushedArguments?.event;
        if (latestPushedEvent === "mutiny_experience_impression") {
            const experienceDetails = {
                experience_id: latestPushedArguments?.experience_id || null,
                experience_name: latestPushedArguments?.experience_name || null,
                experience_type: latestPushedArguments?.experience_type || null,
                personalized: latestPushedArguments?.personalized || null,
                segment_name: latestPushedArguments?.segment_name || null,
                variation_key: latestPushedArguments?.variation_key || null,
                variation_name: latestPushedArguments?.variation_name || null,
            }

            logAmplitudeEvent({
                event_type: "Experiment Viewed",
                properties: experienceDetails
            });
        }


        if (latestPushedEvent === "company_details_loaded") {
            const userCompanyDetails = {
                company_name: latestPushedArguments?.company?.name,
                company_country: latestPushedArguments?.company?.country,
                company_state: latestPushedArguments?.company?.state,
                company_city: latestPushedArguments?.company?.city,
                company_domain: latestPushedArguments?.company?.domain,
                company_employee_range: latestPushedArguments?.company?.employee_range,
                company_revenue_range: latestPushedArguments?.company?.revenue_range,
                company_annual_revenue: latestPushedArguments?.company?.annual_revenue,
                company_6sense_segments: latestPushedArguments?.company?.segmentsIDs,
                confidence_in_data: latestPushedArguments?.confidence
            }

            logAmplitudeEvent({
                setUserProperties: userCompanyDetails
            });
        }

        if (latestPushedEvent === "user_interaction") {
            
            if (latestPushedArguments?.event_name === "view_search_results" || latestPushedArguments?.event_name === 'search_from_nav') {
                const searchDetails = {
                    search_query: latestPushedArguments?.interaction?.search_term
                }

                logAmplitudeEvent({
                    event_type: "Search Performed",
                    properties: searchDetails
                });
            }
        }

        // Calling the original push method with all arguments

        if (!originalDataLayerBusPush) {
            return;
        }

        return originalDataLayerBusPush.apply(window.dataLayerBus, arguments);
    }
}

export default listenToMutinyEventInDataLayer;